module.exports = __webpack_public_path__ + "media/images/norconsult_logo2-e748096f.png";